import * as utils from "../utils";
import * as types from "./constants";
import urls from 'urls';

import store from "../store";

export function fetchGuestlistData() {
  const url = urls.get('ajax_event_guestlist', {
    event_id: window.evite_event.id,
    gid: window.guest_id
  });
  window.$.get(url, (response) => {

    // Exit if it's a hidden guest list
    if (response.length === 0) {
      return false;
    }

    // Sort guests in alphabetical order
    function alphabetical(a, b) {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    }
    response.yes.sort(alphabetical);
    response.no.sort(alphabetical);
    response.maybe.sort(alphabetical);
    response.undecided.sort(alphabetical);

    let hostFound = false;
    let youFound = false;
    for (let respType of ['yes', 'no', 'maybe', 'undecided']) {
      // Bring You to the front
      if (!youFound) {
        response[respType].forEach((guest, idx) => {
          if (guest.user_id === window.user_id) {
            response[respType].unshift(response[respType].splice(idx, 1)[0]);
            youFound = true;
            return false;
          }
        });
      }

      // Bring Host to the front
      if (!hostFound) {
        response[respType].forEach((guest, idx) => {
          if (guest.user_id === window.evite_event.host_id) {
            response[respType].unshift(response[respType].splice(idx, 1)[0]);
            hostFound = true;
            return false;
          }
        });
      }
    }

    store.dispatch({
      type: types.HYDRATE_GUESTLIST,
      data: response
    })
  })
  .fail(function(jqXHR, textStatus, errorThrown) {
    utils.renderAjaxErrorModal(jqXHR, textStatus, errorThrown);
  });
}

export function updateSearchText(searchText) {
  store.dispatch({
    type: types.UPDATE_SEARCH_TEXT,
    searchText
  })
}

export function getNameOfGuestWithId(guestId) {
  return store.getState().guestlist.guestlistData.guest_names[guestId];
}



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/guestlist/actions.es6